import VCalendar from "v-calendar";
import "v-calendar/style.css";

// Use plugin with optional defaults

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(VCalendar, {});
});
